import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TrackingService } from '@markant-platform/shared/util-tracking';
import { MarkantElementsModule } from '@markant/elements-angular';
import { ArrayIncludesPipe } from '@markant-platform/shared/util-pipes';
import { NgClass, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  standalone: true,
  selector: 'markant-platform-registration-page-buttons',
  templateUrl: './registration-page-buttons.component.html',
  styleUrls: ['./registration-page-buttons.component.scss'],
  imports: [MarkantElementsModule, ArrayIncludesPipe, NgClass, TranslocoPipe, NgIf],
})
export class RegistrationPageButtonsComponent {
  @Input({ required: true }) currentStep!: string;
  @Input({ required: true }) submitPage!: string;
  @Input({ required: true }) submitButtonText!: string;
  @Input() closePages: string[] = [];
  @Input() backPages: string[] = [];
  @Input() steps: string[] = [];
  @Input() isCurrentFormInvalid = false;
  @Input() submitIsLoading = false;
  @Input() analyticsRegistrationEventName?: string;
  @Input() analyticsPageVisitTexts?: Record<string, string>;

  @Output() submitChanged = new EventEmitter<boolean>();
  @Output() showErrorsChanged = new EventEmitter<boolean>();
  @Output() currentStepChanged = new EventEmitter<string>();
  @Output() goBack = new EventEmitter<boolean>();
  @Output() closeChanged = new EventEmitter<boolean>();

  constructor(
    private readonly router: Router,
    private readonly trackingService: TrackingService
  ) {}

  nextPage(): void {
    if (this.isCurrentFormInvalid) {
      this.showErrorsChanged.emit(true);
      return;
    }
    this.trackingService.pushButtonClickToDataLayer(
      this.analyticsRegistrationEventName || '',
      this.currentStep,
      this.currentStep === 'WELCOME' ? 'Start' : 'Weiter'
    );
    this.showErrorsChanged.emit(false);
    if (this.currentStep !== this.steps[this.steps.length - 1]) {
      this.currentStepChanged.emit(this.steps[this.steps.indexOf(this.currentStep) + 1]);
    } else {
      this.currentStepChanged.emit(this.currentStep);
    }
  }

  previousPage(): void {
    if (this.currentStep === 'WELCOME' || this.currentStep === 'THANK_YOU') {
      this.goBack.emit(true);
    }
    const index = this.steps.indexOf(this.currentStep) - 1;
    if (index >= 0) {
      this.currentStepChanged.emit(this.steps[index]);
    }
    this.trackingService.pushButtonClickToDataLayer(
      this.analyticsRegistrationEventName || '',
      this.currentStep,
      'Zurück'
    );
  }

  submit(): void {
    if (this.isCurrentFormInvalid) {
      this.showErrorsChanged.emit(true);
      return;
    }
    this.showErrorsChanged.emit(false);
    this.submitChanged.emit(true);
    this.trackingService.pushButtonClickToDataLayer(
      this.analyticsRegistrationEventName || '',
      this.currentStep,
      'Fertig'
    );
  }

  back(): void {
    this.trackingService.pushButtonClickToDataLayer(
      this.analyticsRegistrationEventName || '',
      this.currentStep,
      'Zurück'
    );
    this.router.navigate(['']).then(() => {
      this.closeChanged.emit(true);
    });
  }
}
